import React, { useContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const PrivacyPolicy = () => {

  const location = useLocation();

  useEffect(() => {
    // Remove modal backdrops
    const backdrops = document.querySelectorAll(".modal-backdrop");
    backdrops.forEach((el) => el.remove());

    // Remove modal-open class
    document.body.classList.remove("modal-open");

    // Remove inline styles like overflow and padding
    document.body.style.overflow = "";
    document.body.style.paddingRight = "";

    // Optionally, clear all inline styles (use with caution)
    // document.body.removeAttribute("style");
  }, [location]);


  return (
    <div className="container mx-auto px-4 py-6 max-w-4xl">
      <h1 className="text-3xl font-bold mb-4"><em>Privacy Policy for APM Smart Hub.</em></h1>

      <section className="mb-4">
        <p className="mb-4"><em>Company: APM ECOM MART PRIVATE LIMITED</em></p>
        <p className="mb-4">
          APM ECOM MART PRIVATE LIMITED ("we", "our", "us") operates the mobile application <em>APM Smart Hub</em> ("App").
        </p>
        <p className="mb-4">
          This Privacy Policy describes how we collect, use, store, and protect user information when customers visit stores, purchase items, use the APM wallet coin system, or interact with merchants through the App.
        </p>
        <p className="mb-4">
          By using the App, you agree to the collection and use of information in accordance with this Privacy Policy.
        </p>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>1. Information We Collect</em></h2>
        <p className="mb-4">We collect the following types of information to provide and improve our services:</p>
        
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2"><em>A. Personal Information</em></h3>
          <ul className="list-disc ml-5">
            <li>Name</li>
            <li>Mobile number</li>
            <li>Email address</li>
            <li>Delivery address</li>
            <li>Account login details</li>
          </ul>
        </div>

        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2"><em>B. Transaction Information</em></h3>
          <ul className="list-disc ml-5">
            <li>Purchase history</li>
            <li>Payment method (no card numbers stored)</li>
            <li>Wallet coin usage and balance</li>
            <li>Store visits and vendor interactions</li>
          </ul>
        </div>

        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2"><em>C. Device Information</em></h3>
          <ul className="list-disc ml-5">
            <li>Device model, OS version</li>
            <li>App version</li>
            <li>IP address</li>
            <li>Device identifiers (for security and analytics)</li>
          </ul>
        </div>

        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2"><em>D. Location Information (Optional)</em></h3>
          <p className="mb-2">If you allow location access, we may use it to:</p>
          <ul className="list-disc ml-5">
            <li>Show nearby partner stores</li>
            <li>Enable store visit features</li>
            <li>Improve service availability</li>
          </ul>
          <p className="mt-2">You may disable location permission anytime from your device settings.</p>
        </div>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>2. How We Use Your Information</em></h2>
        <p className="mb-4">Your data is used strictly to operate and improve the APM Smart Hub app:</p>
        <ul className="list-disc ml-5 mb-4">
          <li>To create and manage your user account</li>
          <li>To process purchases and transactions</li>
          <li>To track and redeem wallet coins with the vendor</li>
          <li>To provide order history and receipts</li>
          <li>To improve app performance and user experience</li>
          <li>To detect and prevent fraud</li>
          <li>To provide customer support</li>
          <li>To send important service notifications</li>
        </ul>
        <p>We <em>do not sell or rent</em> your information to third parties.</p>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>3. Wallet Coin System</em></h2>
        <p className="mb-4">APM Smart Hub offers a special <em>APM Wallet Coin</em> feature:</p>
        <ul className="list-disc ml-5 mb-4">
          <li>Coins are added by authorized store vendors</li>
          <li>Customers may use coins on future purchases</li>
          <li>All coin activity is recorded for security</li>
          <li>Misuse of coins may lead to account suspension</li>
        </ul>
        <p>Wallet coins <em>have no real currency value</em> outside the App unless specified by the company.</p>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>4. Sharing of Information</em></h2>
        <p className="mb-4">We share user data only when necessary:</p>
        
        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2"><em>A. With Vendors / Partner Stores</em></h3>
          <ul className="list-disc ml-5">
            <li>To confirm customer visits</li>
            <li>To track purchases and coin rewards</li>
            <li>To redeem wallet coins</li>
          </ul>
        </div>

        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2"><em>B. With Service Providers</em></h3>
          <p className="mb-2">(For app hosting, payment processing, analytics)</p>
          <p>All partners follow strict confidentiality agreements.</p>
        </div>

        <div className="mb-4">
          <h3 className="text-xl font-semibold mb-2"><em>C. Legal Requirements</em></h3>
          <p className="mb-2">We may share information to:</p>
          <ul className="list-disc ml-5">
            <li>Comply with a legal obligation</li>
            <li>Prevent fraud or security breaches</li>
            <li>Protect the rights of our users and our company</li>
          </ul>
        </div>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>5. Data Security</em></h2>
        <p className="mb-4">We use industry-standard safeguards to protect your data:</p>
        <ul className="list-disc ml-5 mb-4">
          <li>Encrypted communication (HTTPS)</li>
          <li>Secure servers</li>
          <li>Limited employee access</li>
          <li>Regular security audits</li>
        </ul>
        <p>However, no method of transmission or storage is 100% secure.</p>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>6. Data Retention</em></h2>
        <p className="mb-4">We retain user data only as long as necessary:</p>
        <ul className="list-disc ml-5 mb-4">
          <li>Account data: until you delete your account</li>
          <li>Transaction records: as required by law</li>
          <li>Wallet coin records: for fraud prevention and account history</li>
        </ul>
        <p>You may request data deletion anytime (see Section 9).</p>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>7. Children's Privacy</em></h2>
        <p>The App is not intended for children under <em>13 years</em>.</p>
        <p>We do not knowingly collect data from minors.</p>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>8. Your Rights</em></h2>
        <p className="mb-4">Depending on your region, you may have the right to:</p>
        <ul className="list-disc ml-5 mb-4">
          <li>Access your personal data</li>
          <li>Update or correct data</li>
          <li>Request deletion of your data</li>
          <li>Disable permissions (camera, location, notifications)</li>
          <li>Opt out of promotional messages</li>
        </ul>
        <p>To request these actions, contact us at the email given below.</p>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>9. Account & Data Deletion</em></h2>
        <p className="mb-4">You can request deletion of your account and associated data by contacting support at:</p>
        <p className="mb-4"><em>support@apmsmarthub.com</em></p>
        <p>Once deleted, account information <em>cannot be recovered</em>.</p>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>10. Third-Party Services Used in the App</em></h2>
        <p className="mb-4">The App may use third-party services such as:</p>
        <ul className="list-disc ml-5 mb-4">
          <li>Payment gateways</li>
          <li>Analytics providers</li>
          <li>Crash reporting tools</li>
        </ul>
        <p>These services may collect limited information as per their own privacy policies.</p>
      </section>

      <hr className="my-6" />

      <section className="mb-6">
        <h2 className="text-2xl font-semibold mb-4"><em>11. Changes to This Privacy Policy</em></h2>
        <p className="mb-2">We may update this Privacy Policy from time to time.</p>
        <p className="mb-2">Updates will be posted within the App.</p>
        <p>Continued use of the App means you accept the revised policy.</p>
      </section>

      <hr className="my-6" />

      <section>
        <h2 className="text-2xl font-semibold mb-4"><em>12. Contact Us</em></h2>
        <p className="mb-4">For questions or concerns about this Privacy Policy, contact:</p>
        <p className="mb-2"><strong><em>APM ECOM MART PRIVATE LIMITED</em></strong></p>
        <p className="mb-2">Email: support@apmsmarthub.com</p>
        <p className="mb-2">Phone: +91 94816 99771</p>
        
      </section>
    </div>
  );
};

export default PrivacyPolicy;
